import type { FC } from 'react';
import React from 'react';
import type { SkeletonProps } from '@mui/material/Skeleton';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import { StyledSkeletonContent } from '@shared/SkeletonContent/SkeletonContent.style';

export const SkeletonContent: FC<SkeletonProps> = () => (
  <StyledSkeletonContent>
    <Box className="content">
      <p>
        <Skeleton variant="rectangular" width="100%" height={12} />
        <Skeleton variant="rectangular" width="65%" height={12} />
      </p>
      <h2>
        <Skeleton variant="rectangular" width="45%" height={44} />
      </h2>
      <p>
        <Skeleton variant="rectangular" width="90%" height={12} />
        <Skeleton variant="rectangular" width="100%" height={12} />
        <Skeleton variant="rectangular" width="65%" height={12} />
      </p>
      <p>
        <Skeleton variant="rectangular" width="100%" height={12} />
        <Skeleton variant="rectangular" width="35%" height={12} />
      </p>
      <h2>
        <Skeleton variant="rectangular" width="55%" height={44} />
      </h2>
      <p>
        <Skeleton variant="rectangular" width="75%" height={12} />
        <Skeleton variant="rectangular" width="100%" height={12} />
        <Skeleton variant="rectangular" width="65%" height={12} />
      </p>
    </Box>
    <Box className="toc">
      <Skeleton variant="rectangular" width={80} height={15} />
      <Box className="toc__items">
        <Skeleton variant="rectangular" width={205} height={12} />
        <Skeleton variant="rectangular" width={170} height={12} />
        <Skeleton variant="rectangular" width={190} height={12} />
        <Skeleton variant="rectangular" width={205} height={12} />
        <Skeleton variant="rectangular" width={170} height={12} />
        <Skeleton variant="rectangular" width={130} height={12} />
      </Box>
    </Box>
  </StyledSkeletonContent>
);
